// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactDOM from 'react-dom';
import AppDispatcher from './../../flux/AppDispatcher';
import SlideOutTabConstants from './../../constants/SlideOutTabConstants';
var dispatcher = AppDispatcher.get(SlideOutTabConstants.DISPATCHER);

dispatcher.register((payload: any) => {
    switch (payload.actionType) {
        case SlideOutTabConstants.OPEN:
            let tabId = payload.tabId;
            let setId = payload.setId;
            if (slideOutTabSet[setId]) {
                for (var indx in slideOutTabSet[setId]) {
                    let slideOutTab = slideOutTabSet[setId][indx];
                    if (slideOutTab.props.tabId === payload.tabId) {
                        if (!slideOutTab.state.isOpen) {
                            (slideOutTab as any)._handleTabClick();
                        }
                    }
                }
            }
            break;
        case SlideOutTabConstants.CLOSE:
            tabId = payload.tabId;
            setId = payload.setId;
            if (slideOutTabSet[setId]) {
                for (var indx in slideOutTabSet[setId]) {
                    let slideOutTab = slideOutTabSet[setId][indx];
                    if (slideOutTab.props.tabId === payload.tabId) {
                        if (slideOutTab.state.isOpen) {
                            (slideOutTab as any)._handleTabClick();
                        }
                    }
                }
            }
            break;
        case SlideOutTabConstants.FLASH:
            tabId = payload.tabId;
            setId = payload.setId;
            if (slideOutTabSet[setId]) {
                for (var indx in slideOutTabSet[setId]) {
                    let slideOutTab = slideOutTabSet[setId][indx];
                    if (slideOutTab.props.tabId === payload.tabId) {
                        (slideOutTab as any)._handleTabFlash();
                    }
                }
            }
            break;
    }
});

interface SlideOutTabProps extends React.PropsWithChildren<{}> {
    tabName: string;
    slideRight?: boolean;
    tabSet?: string;
    defaultOpen?: boolean;
    tabId?: string;
    onChangeOpenState?: (isOpen: boolean) => void;
}

interface SlideOutTabState {
    isOpen: boolean;
    flash: boolean;
    randId?: string;
}

var slideOutTabSet: { [id: string]: SlideOutTab[] } = {};

class SlideOutTab extends React.Component<SlideOutTabProps, SlideOutTabState> {

    slideoutIndex: number;
    portalContainer: HTMLElement;
    closing: boolean;
    slideoutTab: HTMLSpanElement;

    constructor(props: SlideOutTabProps, context: any) {
        super(props, context);

        this.state = {
            isOpen: this.props.defaultOpen,
            flash: false,
            randId: (Math.random() + (new Date()).getTime()).toString().replace('.', '-')
        };
    }

    private _handleTabClick = () => {
        if (this.props.tabSet !== undefined) {
            this._closeOpenSlideouts();
        }
        this.setState((state) => { return { isOpen: !state.isOpen } });
    }

    private _handleTabFlash = () => {
        this.setState({ flash: true });
    }

    private _flashAnimationFinished = () => {
        this.setState({ flash: false })
    }

    // This function will close other slideouts if it is a part of a tabset and another slideout is opened
    private _closeOpenSlideouts = () => {
        var slideOuts = slideOutTabSet[this.props.tabSet];
        for (var i = 0; i < slideOuts.length; i++) {
            var slideout = slideOuts[i];
            if (slideout !== this) {
                slideout.setState({ isOpen: false });
            }
            else {
                slideout.setState({});
            }
        }
    }

    UNSAFE_componentWillMount() {
        this.portalContainer = document.getElementById(this.state.randId);

        if (this.props.tabSet) {
            if (!slideOutTabSet[this.props.tabSet]) {
                slideOutTabSet[this.props.tabSet] = [this];
            } else {
                slideOutTabSet[this.props.tabSet].push(this);
                if (this.state.isOpen) {
                    this._closeOpenSlideouts();
                };
            }
            this.slideoutIndex = slideOutTabSet[this.props.tabSet].indexOf(this);
        }
    }

    componentDidMount() {
        if (this.slideoutTab) {
            this.slideoutTab.addEventListener('animationend', this._flashAnimationFinished);
        }
    }

    componentWillUnmount() {
        if (this.slideoutTab) {
            this.slideoutTab.removeEventListener('animationend', this._flashAnimationFinished);
        }

        if (this.props.tabSet) {
            var closedSlideout = slideOutTabSet[this.props.tabSet].indexOf(this);
            if (closedSlideout > -1) {
                slideOutTabSet[this.props.tabSet].splice(closedSlideout, 1);
            }
        }

        if (this.portalContainer && !this.closing) {
            this.portalContainer.onclick = null;
            $(this.portalContainer).remove();
            this.portalContainer = null;
        }
    }

    componentDidUpdate(prevProps: SlideOutTabProps, prevState: SlideOutTabState) {
        if (prevState.isOpen !== this.state.isOpen) {
            if (this.props.onChangeOpenState) {
                this.props.onChangeOpenState(this.state.isOpen);
            }
        }
    }

    render() {
        var slideRight = this.props.slideRight ? 'from-right' : '';
        var isOpen = this.state.isOpen ? 'tab-active' : '';
        var flash = this.state.flash ? 'flash' : '';

        return (
            <div id={this.state.randId} className={`slideout-container ${slideRight} ${isOpen}`}>
                <div className='tab-panel-container tab-panel'>
                    <div className="cd-panel-content">
                        {this.props.children}
                    </div>
                </div>
                <span className={`slideout-tab tail ${flash ? "" : "hidden"}`} style={{ position: "absolute", top: `${this.slideoutIndex * 150}px` }}></span>
                <span className={`slideout-tab ${flash}`} style={{ position: "absolute", top: `${this.slideoutIndex * 150}px` }}
                    ref={obj => this.slideoutTab = obj } onClick={this._handleTabClick}>{this.props.tabName}</span>
            </div>
        )
    }
}

export default SlideOutTab;